import type { WithAuthenticatorProps } from '@aws-amplify/ui-react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import configureAmplify from '../utils/amplifyConfig';
configureAmplify();

function Logout({ signOut, user }: WithAuthenticatorProps) {
  return (
    <>
      <button className="btn btn-sm" onClick={signOut}>Sign out</button>
    </>
  );
}

export default withAuthenticator(Logout);